import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    addScollClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';

import GLightbox from 'glightbox';


//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    addScollClass('100px', 'scroll');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            $('html,body').animate({ 'scrollTop': ($(this).offset().top - $(this).height()) + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder').animate({ 'scrollTop': '0px' }, 0);
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });

        /*
                if ($('.footer1__slide').length > 1) {
                    let slideInterval;
                    let isSliderVisible = false;
        
                    // Funkcja do zmiany slajdów
                    const changeSlide = function () {
                        let nextActive = $('.footer1__slide.active').next();
                        if (nextActive.length == 0) {
                            nextActive = $('.footer1__slide').first();
                        }
                        $('.footer1__slide.active').removeClass('active');
                        nextActive.addClass('active');
                    };
        
                    // Funkcja do uruchamiania/zatrzymywania slidera
                    const toggleSlider = function (visible) {
                        if (visible && !isSliderVisible) {
                            isSliderVisible = true;
                            slideInterval = window.setInterval(changeSlide, 5000);
                        } else if (!visible && isSliderVisible) {
                            isSliderVisible = false;
                            clearInterval(slideInterval);
                        }
                    };
        
                    // Intersection Observer - uproszczony dla jednego elementu
                    const observer = new IntersectionObserver(function (entries) {
                        // Tylko jeden entry, bo jeden slider na stronie
                        toggleSlider(entries[0].isIntersecting);
                    }, {
                        threshold: 0.1 // Slider jest widoczny gdy przynajmniej 10% jest na ekranie
                    })
                    // Obserwuj kontener slidera - jeden na stronie
                    const sliderContainer = document.querySelector('.footer1__slider');
                    if (sliderContainer) {
                        observer.observe(sliderContainer);
                    }
                };
        */

        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (window.innerWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });





        const lightbox = GLightbox({
            selector: ".glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a",
            slideEffect: 'fade',
            loop: true,
            dragAutoSnap: true,
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);





